import React, { useState, useEffect } from 'react';
import Box from './Box';
import Toast from './Toast';
import Tools from './Tools';

const TaskTreeFilter = (props) => {

    const [contactTypes, setContactTypes] = useState([]);
    const [taskTypes, setTaskTypes] = useState([]); 
    const [error, setError] = useState(false);
    const [toastRef, setToastRef] = useState(React.createRef()); 
    const [currentCompanyId, setCurrentCompanyId] = useState(null);
    const [showListofTaskTypes, setShowListofTaskTypes] = useState(false);
    const [loadingTaskTypes, setLoadingTaskTypes] = useState(false);
    const [loadingTaskFields, setLoadingTaskFields] = useState(false);
    const [data, setData] = useState({ contactType: 0, taskType: 0 }); 
    const [reset, setReset] = useState(false);

    useEffect(() => {
        setCurrentCompanyId(props.companyId);

        //contactTypes
        fetch(`${process.env.REACT_APP_URI_API_CRM}/contactTypes?idCompany=${props.companyId}`)
        .then(res => res.json())
        .then(
            (result) => {
                setContactTypes(result);
            },
            (error) => {
                setError(error);
            }
        )


    }, [props.client]);


    useEffect(() => { //HACK TO CLEAN TASKTYPE AND VALIDATE TASKTREE
        setData({ ...data, ['taskType']: 0 });
    }, [data.contactType]);



    const handleInputChange = (event) => {
        setData({ ...data, [event.target.name]: event.target.value })
    }

    const getTaskTypesForContactType = (event) => {
        handleInputChange(event);
        getTaskTypes(event.target.value);
        props.setContactType(event.target.value);
    }

    const informTaskType = (event) => {
        handleInputChange(event);
        props.setTaskType(event.target.value);
    }


    const getTaskTypes = (contactType) => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        setShowListofTaskTypes(false);
        setLoadingTaskTypes(true);
        let url = new URL(`${process.env.REACT_APP_URI_API_CRM}/taskTypes`);
        url.search = new URLSearchParams({
            contactTypeId: contactType,
        });

        fetch(url, {
            method: 'GET',
            contentType: 'application/json',
            headers: { 'Authorization': currentSessionData.token }
        })
        .then(res => res.json())
        .then(
            (result) => {
                setTaskTypes(result);
                setShowListofTaskTypes(true);
                setLoadingTaskTypes(false);
            },
            (error) => {
                console.log('Se produjo un errrooooor:', error);
                setError(error);
                setShowListofTaskTypes(false);
                setLoadingTaskTypes(false);
            }
        )
    }

    const resetFilter=()=>{
        setReset(!reset);
        setData({ ...data, ["contactType"]: undefined });
        setTaskTypes([]);
        props.setContactType(undefined);
    }

    return (
        <div>
            <Toast ref={toastRef}></Toast>
            <h5 className='sectionTitle'>
                FILTRO ARBOL DE GESTIÓN 
                {data.contactType!==0 && data.contactType!==undefined?(<a className='clear' onClick={resetFilter}>LIMPIAR</a>):null}
            </h5>    
            <div className="flexRow">
                <div className="flexCol">
                    <Box type="select" key={reset} name="contactType" label="Tipo de contacto" className="x2" placeholder="Seleccione ..." options={contactTypes} onChange={getTaskTypesForContactType} required></Box>
                    <Box type="select" key={data.contactType + reset} name="taskType" label="Tipo de gestión" className={loadingTaskFields ? 'x4 loading' : 'x4'} placeholder="Seleccione ..." options={taskTypes} onChange={informTaskType} required></Box>
                </div>
            </div>
        </div>
    );

}

export default TaskTreeFilter;





